import React from 'react';
import home from './home';
import error from './error';
import textInfo from './home_txt'


const navBar = (
  <div>
  <nav className="navbar navbar-dark bg-dark flex-md-nowrap p-0 shadow bg-primary fixed-top">
    <a className="navbar-brand col-sm-3 col-md-2 mr-0" href="https://github.com/liesware/">Liesware</a>
    <a className="text-info col-sm-3 col-md-3 mr-0" href="https://uncovering-cicada.fandom.com/wiki/Uncovering_Cicada_Wiki" target="_blank">Alea iacta est</a>
     <ul className="navbar-nav px-3">
    </ul>
  </nav>

  <div className="container-fluid">
    <div className="row">

      <nav className="col-md-2 d-none d-md-block bg-light sidebar">
        <div className="sidebar-sticky">
          <ul className="nav flex-column">

            <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>Site Map</span>
            </h6>
            <ul className="nav flex-column mb-2">
              <li className="nav-item">
                <a className="nav-link" href="#"  onClick={home} >
                  <span data-feather="file-text"></span>
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#"  onClick={error} >
                  <span data-feather="file-text"></span>
                  404
                </a>
              </li>
            </ul>


          </ul>
        </div>
      </nav>


      <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
        <span id="workPlace">
          {textInfo}
        </span>
      </main>
    </div>
  </div>

  </div>

);

export default navBar
